export default {

    ProformaBills: 'Proforma Invoice|Proforma Invoices',
};
